module.exports = __webpack_public_path__ + "static/media/masterCard.505c21f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/openpay/masterCard.png
// module id = 171
// module chunks = 0